import { useEffect } from 'react'

export const useTiktokPixelInitialization = (): void => {
  useEffect(() => {
    window.ttq.load('CDPORGRC77U4N56LA8RG')
    window.ttq.load('CQF5F6RC77U1KLFIK980')
    window.ttq.page()

    const searchParams = new URLSearchParams(document.location.search)
    const ttclid = searchParams.get('ttclid')

    if (ttclid) {
      // Send somewhere? New subs BE doesn't have POST v2/leads/${uuid}/tiktok
    }
  }, [])
}
